














import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import DictAPI from '@/services/rest/bemob/dictionary';
import ThreePanelCondition from './three-panel-condition/three-panel-condition.vue';

@Component({
  components: {
    ThreePanelCondition
  }
})
export default class BrandAndModel extends Vue {
  @Prop() target: any;
  @Prop() conditions: any;

  @Emit('close')
  onClose() {}

  prefix: string = 'brand';
  data: any[] = [];
  loading: boolean = false;

  get title() {
    return this.t('Brand and model');
  }

  get name() {
    return this.t('Brands');
  }

  created() {
    this.loading = true;
    (new DictAPI()).get('brands-v2', {}).then((brands: any) => {

      this.data = Object.keys(brands).map((e: any) => {
        return { name: e, selected: false, picked: false, data: brands[e] };
      });
      this.loading = false;
    });
  }
}
